import type { IconSvgObject } from './types';

const StrategyIcon: IconSvgObject = [
  ["path", { d: "M18 11L20.3458 8.84853C20.7819 8.44853 21 8.24853 21 8M18 5L20.3458 7.15147C20.7819 7.55147 21 7.75147 21 8M21 8C3 8 3 21 3 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "5.5", cy: "5.5", r: "2.5", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M13 21L18 16M18 21L13 16", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }]
];

export default StrategyIcon;
